module.exports = __webpack_public_path__ + "static/img/taide-art-TAIDE-white.649aafb.svg";